module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-1000.874760f1.svg";